import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  FormControl,
  Grid,
  Input,
  InputLabel,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import TextMaskCustom from "../../TextMaskCustom/TextMaskCustom";
import { useMutation } from "react-query";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const FeedbackForm = ({ contact }) => {
  const [notificationOpen, setNotificationOpen] = useState(false);
  const navigate = useNavigate();

  const { mutate, isLoading } = useMutation(
    async (formData) => {
      const response = await axios.post(
        "https://api.odigital.app/api/feedback_create/",
        formData
      );
      return response.data;
    },
    {
      onSuccess: () => {
        setNotificationOpen(true);
        setTimeout(() => {
          navigate("/success-page");
        }, 1000);
      },
      onError: (error) => {
        console.error(error.message);
      },
    }
  );

  const [values, setValues] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleSubmit = (event) => {
    event.preventDefault();
    mutate(values);
    setValues({ name: "", phone: "", email: "", message: "" });
  };

  const handleNotificationClose = () => {
    setNotificationOpen(false);
  };

  return (
    <Box component="form" width="100%" onSubmit={handleSubmit} overflow="hidden">
      <Typography variant="h3" fontWeight="600">
        Связаться с нами
      </Typography>
      <Grid container fontSize="20px">
        <Grid item xs={12} sx={{ marginY: "20px" }}>
          <TextField
            label="Ваше имя"
            type="text"
            variant="standard"
            fullWidth
            required
            value={values.name}
            onChange={(event) =>
              setValues({ ...values, name: event.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sx={{ marginY: "20px" }}>
          <FormControl variant="standard" fullWidth required>
            <InputLabel htmlFor="formatted-text-mask-input">
              Ваш номер телефона
            </InputLabel>
            <Input
              value={values.phone}
              onChange={(event) =>
                setValues({ ...values, phone: event.target.value })
              }
              name="textmask"
              id="formatted-text-mask-input"
              inputComponent={TextMaskCustom}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sx={{ marginY: "20px" }}>
          <TextField
            label="Ваш E-mail"
            type="email"
            variant="standard"
            fullWidth
            required
            value={values.email}
            onChange={(event) =>
              setValues({ ...values, email: event.target.value })
            }
          />
        </Grid>
        <Grid item xs={12} sx={{ marginTop: "20px" }} marginBottom="50px">
          <TextField
            label="Ваше сообщение"
            variant="standard"
            fullWidth
            required
            value={values.message}
            onChange={(event) =>
              setValues({ ...values, message: event.target.value })
            }
            multiline
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            style={{ opacity: isLoading ? 0.5 : 1 }}
            type="submit"
            fullWidth
            sx={{
              fontSize: "20px",
              py: "10px",
              color: "#5699E8",
              border: "1px solid #5699E8",
              borderRadius: "47px",
              textTransform: "none",
              ":hover": { background: "#5699E8", color: "#fff" },
            }}
          >
            {isLoading ? "Загрузка..." : "Отправить"}
          </Button>
        </Grid>
      </Grid>
      <Snackbar
        open={notificationOpen}
        autoHideDuration={5000}
        onClose={handleNotificationClose}
      >
        <Alert
          onClose={handleNotificationClose}
          severity="success"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Ваш вопрос успешно отправлен!
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default FeedbackForm;
